// 接口 - 对账
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 公众号坐席维护列表查询接口
export function getGzhList(params){
  return get(`${baseApi}/weChatApi/getGzhList`, params);
}

// 公众号坐席编辑接口
export function editGzhSeat(params){
    return post(`${baseApi}/weChatApi/editGzhSeat`, params);
}

// 枚举下拉框
export function getAllEnum(params){
  return get(`${baseApi}/weChatApi/getAllEnum`, params);
}

// 客户列表查询接口
export function getWxGzhCusList(params){
    return post(`${baseApi}/weChatApi/getWxGzhCusList`, params);
}

// 聊天消息查询接口
export function getChatList(params){
    return get(`${baseApi}/weChatApi/getChatList`, params);
}

// 客服发送消息接口
export function sendMsg(params){
    return post(`${baseApi}/weChatApi/sendMsg`, params);
}
// 获取callId查询工单ID
export function getIdByCallId(params){
    return get(`${baseApi}/jobOrder/getIdByCallId`, params);
}
